/* Nívola – helpers (carrito, toast) */
(function(){
  function toast(msg){var t=document.querySelector('.nv-toast');if(!t){t=document.createElement('div');t.className='nv-toast';document.body.appendChild(t);}t.textContent=msg;t.classList.add('is-on');clearTimeout(t._h);t._h=setTimeout(function(){t.classList.remove('is-on');},2600);}
  window.nvToast=toast;
  async function openCart(){
    var d=document.querySelector('cart-drawer-component');
    if(d&&typeof d.open==='function'){try{d.open();return true;}catch(e){}}
    var b=document.querySelector('[data-testid="cart-drawer-trigger"],.header-actions__cart-icon button,button[aria-controls*="cart"]');
    if(b){b.click();return true;}
    return false;
  }
  window.nvAdd=async function(id,qty,btn){
    if(!id)return;if(btn)btn.classList.add('is-loading');
    try{
      var r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:Number(qty)||1}]})});
      var j=await r.json();
      if(!r.ok)throw new Error(j.description||j.message||'No se pudo agregar');
      var cart=await (await fetch('/cart.js',{headers:{'Accept':'application/json'}})).json();
      document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:cart,sourceId:'nv-add',data:{source:'nv-add',itemCount:cart.item_count,variantId:String(id)}}}));
      toast('Agregado al carrito');
      setTimeout(function(){openCart().then(function(ok){if(!ok)location.href='/cart';});},150);
    }catch(e){toast(e.message||'No se pudo agregar');}
    finally{if(btn)btn.classList.remove('is-loading');}
  };
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-nv-add]');
    if(!b)return;e.preventDefault();
    var q=1;var qs=b.getAttribute('data-nv-qty');if(qs){var el=document.querySelector(qs);if(el)q=el.value;}
    window.nvAdd(b.getAttribute('data-nv-add'),q,b);
  });
})();
